import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CartModule, UserEcommerceModule, EcommerceJadeGroupModule } from 'ecommerce-jade-group-plugin';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { DeliveryInfoComponent } from './shared/components/delivery-info/delivery-info.component';
import { SharedModule } from './shared/shared.module';
import { AgmCoreModule } from '@agm/core';
import { NgxMaskModule } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { NgZorroAntdModule, NZ_ICONS } from 'ng-zorro-antd';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { NZ_I18N, en_US } from 'ng-zorro-antd';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './shared/services/interceptor';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DeviceDetectorService } from 'ngx-device-detector';

registerLocaleData(en);

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key])

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    DeliveryInfoComponent
  ],
  entryComponents: [
    FooterComponent,
    HeaderComponent,
    DeliveryInfoComponent
  ],
  imports: [
    NgZorroAntdModule,
    DeviceDetectorModule.forRoot(),
    EcommerceJadeGroupModule.forRoot({
      BackendUrl: environment.backend,
      RestaurantType: 1,
      RestaurantName: 'Jade Teriyaki',
      RestaurantLogoUrl: 'https://s3.amazonaws.com/cdn.restaurantes.conectate.com.do/wp-content/uploads/2018/10/17205834/jadeteriyakilogo.jpg',
      appKeyPusher: environment.appKeyPusher,
      hasDelivery: true,
      paymentGateway: 0,
      cardnetCaptureUrl: environment.cardnetCaptureUrl,
      cardnetPublicKey: environment.cardnetPublicKey,
      azulSite: environment.azulSite,
      azulMerchantId: environment.azulMerchantId,
      azulMerchantType: 'MerchantType',
      azulApprovedUrl: '#/menu?Approved=true',
      azulDeclinedUrl: '#/carrito?declined=true',
      azulCancelUrl: '#/carrito?cancel=true',
      dolarRate: 54,
      hasEcommerceActivated: true,
    }),
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    CartModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: true
    }),
    UserEcommerceModule,
    NgxMaskModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD00q2hZ0qs1893SG7Z7UEB1nXHQ46pVAI',
      libraries: ['places']
    }),
  ],
  providers: [
    DeviceDetectorService,
    { provide: NZ_I18N, useValue: en_US }, { provide: NZ_ICONS, useValue: icons },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
